import { render, staticRenderFns } from "./BaseDraggableModal.vue?vue&type=template&id=c04bfa48&"
import script from "./BaseDraggableModal.vue?vue&type=script&lang=js&"
export * from "./BaseDraggableModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseDraggableModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports